/**
* Testimonial Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial Slider component.
*/

import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'testimonial-slider-single',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.testimonial-slider-single' ).length ) {
        $( '.testimonial-slider-single' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perPage: 1,
            perMove: 1,
            pagination: false,
            speed: 800,
          } ).on( 'setPosition', function( event, slick ) {
            // set all slides to height of tallest slide
            slick.$slides.css( 'height', slick.$slideTrack.height() + 'px' );
          } );

          const applyOverflowState = ( isOverflow ) => {
            const root = splide.root;

            if ( !isOverflow ) {
              // Go static
              splide.options = {type: 'slide', arrows: false, drag: false};
              root.classList.add( 'is-static' );
            } else {
              // Re-activate slider
              splide.options = {type: 'loop', arrows: true, drag: true};
              root.classList.remove( 'is-static' );
            }
          };

          // Fires on mount/refresh when Splide recalculates layout
          splide.on( 'overflow', applyOverflowState );

          // Debounced refresh so we don't thrash on continuous resize
          let rafId;
          const refresh = () => {
            if ( rafId ) cancelAnimationFrame( rafId );
            rafId = requestAnimationFrame( () => splide.refresh() );
          };

          // Splide emits 'resize' itself; also handle 'updated'
          splide.on( 'resize', refresh );
          splide.on( 'updated', refresh );

          // Also listen for CSS breakpoint crossings (helps some layouts)
          [window.matchMedia( '(max-width: 1024px)' ),
            window.matchMedia( '(max-width: 768px)' )].forEach( ( mq ) => {
            mq.addEventListener( 'change', refresh );
          } );

          splide.mount( {} );
        } );
      }

      if ( $( '.marquee__splide' ).length ) {
        $( '.marquee__splide' ).each( function( index, element ) {
          // Skip if already initialized
          if ( $( element ).data( 'marquee-initialized' ) ) {
            return;
          }

          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: 'free',
            gap: '2rem',
            arrows: false,
            autoWidth: true,
            pagination: false,
            autoScroll: {
              speed: .75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );

          const section = $( element );
          const sectionWidth = section.width();
          const doubleSectionWidth = sectionWidth * 2;
          let iterations = 0;
          const maxIterations = 10;
          let totalWidth = 0;
          const slides = section.find( `.splide__slide` );
          slides.each( function() {
            totalWidth += $( this ).width();
          } );

          while ( totalWidth < doubleSectionWidth && iterations < maxIterations ) {
            if ( totalWidth < doubleSectionWidth ) {
              slides.each( function() {
                // Clone each slide and append it to the marquee-track
                const clonedSlide = $( this ).clone();
                section.find( '.splide__list' ).append( clonedSlide );
                // Update the total width with the width of the cloned slide
                totalWidth += clonedSlide.width();
              } );
            }
            iterations++;
          }

          slider.mount( {AutoScroll} );
          $( element ).data( 'marquee-initialized', true );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial-slider-single', COMPONENT );
} )( app );
